import { Box, IconButton, Tooltip } from '@mui/material'
import AddActionButton from './AddActionButton';
import AddIcon from 'icons/AddIcon';
import { colors } from 'styles/colors';
import { extractPhotos } from 'common/utils';
import { useGetProductSuggestionById, useGetProductSuggestions, useSuggestProduct } from 'hooks/useProductSuggestion';
import { useGetProductByBarcode } from 'hooks/useProduct';

interface Props {
  productData: any;
}



export default function BeautyProductActionButtons({ productData }: Props) {


  const { data: suggestion, refetch } = useGetProductSuggestions({
    page: 1,
    size: 1,
    barcode: productData.code,
  }, {
    enabled: !!productData.code,
    onSuccess: (data: any) => { },
    onError: () => console.log('error'),
    select: (res: any) => res.data[0],
  });

  const { mutate: suggestMutation, isLoading } = useSuggestProduct(
    (res: any) => console.log('res', res),
    (err: any) => console.log('err', err),
  );


  const onAddPress = () => {
    const photos = extractPhotos(productData);
    const images = photos.map(img => img.large);
    const n = Math.floor(Math.random() * (150 - 25 + 1)) + 25;

    console.log('payload', {
      barcode: productData.code,
      images,
      price: n,
    });

    suggestMutation({
      barcode: productData.code,
      images: images as string[],
      price: n,
    });
  }

  return (
    <Box
      display={'flex'}
      gap={1}
    >
      {!suggestion && <Tooltip title={'Add'}>
        <IconButton
          onClick={onAddPress}
          loading={isLoading}
          disabled={isLoading}
          sx={{
            width: 25,
            height: 25,
            backgroundColor: colors.view,
            borderRadius: '4px',
            padding: 0,
            '&:hover': {
              backgroundColor: colors.view,
            },
          }}
        >
          <AddIcon color='white' size={12} />
        </IconButton>
      </Tooltip>}
    </Box>
  )
}
